import { SortDescriptor } from 'react-aria-components'
import { actionKey, ContactGoalConfig, statusKey } from './constants'
import moment from 'moment'
import { DateValue, parseDate, parseDateTime } from '@internationalized/date'

export const contactGoalConfigSortBy = (sortDescriptor: SortDescriptor) => {
  let sortFunction: (a: ContactGoalConfig, b: ContactGoalConfig) => number
  switch (sortDescriptor.column) {
    case 'goalId':
      sortFunction = sortByGoalId
      break
    case 'name':
      sortFunction = sortByName
      break
    case 'contactGoalActionId':
      sortFunction = sortByAction
      break
    case 'status':
      sortFunction = sortByStatus
      break
    default:
      sortFunction = sortByGoalId
  }

  return (a: ContactGoalConfig, b: ContactGoalConfig) => {
    const cmp = sortFunction(a, b)
    return sortDescriptor.direction === 'descending' ? cmp * -1 : cmp
  }
}

const sortByGoalId = (a: ContactGoalConfig, b: ContactGoalConfig) => {
  return a.goalId < b.goalId ? -1 : 1
}

const sortByName = (a: ContactGoalConfig, b: ContactGoalConfig) => {
  return a.name < b.name ? -1 : 1
}

const sortByAction = (a: ContactGoalConfig, b: ContactGoalConfig) => {
  const first = actionKey[a.contactGoalActionId] || a.contactGoalActionId
  const second = actionKey[b.contactGoalActionId] || b.contactGoalActionId
  return first < second ? -1 : 1
}

const sortByStatus = (a: ContactGoalConfig, b: ContactGoalConfig) => {
  const first = statusKey[a.status] || a.status
  const second = statusKey[b.status] || b.status
  return first < second ? -1 : 1
}

//converte DateValue to string in "YYYY-MM-DD HH:mm" format
export  const convertDateToString = (date: DateValue | null) => {
  if (!date) {
    return null
  }
  const isoString = date.toString()
  const formattedDate = moment(isoString).format('YYYY-MM-DD HH:mm')
  return formattedDate
}

// Convert dateString or timestamp to utc DateTimeValue
export const convertDateToDateTimeValue = (date: number | string | null): DateValue | undefined => {
  if (date === null) {
    return undefined
  }
  if (typeof date === 'string') {
    const  dateString = moment.utc(date, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DDTHH:mm:ss')// Convert to ISO 8601 format (e.g., "2025-04-09T08:15:00")
    return parseDateTime(dateString)
  }
  if (typeof date === 'number') {

    const formattedDate = moment.utc(date).format('YYYY-MM-DDTHH:mm:ss')
    return parseDateTime(formattedDate)
  }
}

// Convert dateString (e.g., "2025-04-09 08:15:00") or timestamp to utc DateValue
export const convertDateToDateValue = (date: number | string | null): DateValue | undefined => {
  if (date === null) {
    return undefined
  }
  if (typeof date === 'string') {
    const dateString = moment.utc(date, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD')// Convert to ISO 8601 format (e.g., "2025-04-09T08:15:00")
    return parseDate(dateString)
  }
  if (typeof date === 'number') {
    const formattedDate = moment.utc(date).format('YYYY-MM-DD')
    return parseDate(formattedDate)
  }
}
